var path = 'batch/bulkRestore/info/bulkRestoreInfo.tpl.html';
var html = "<react-component name='activity-restore-info' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;